import { Expr } from "../../Expr";
import { OrXpr } from "./OrXpr";
import { binaryExpr, BinaryExprStructure } from "../../BinaryExpr";

export interface AndXpr extends BinaryExprStructure {
  $type: "&&";
  left: Expr;
  right: Expr;
}

export const andExpr = (left: Expr, right: Expr): OrXpr => {
  return binaryExpr("&&", left, right) as OrXpr;
};
